
import React from 'react';
import { SectionPortfolio } from './updatedportfolio';

export const Portfolio: React.FC = () => {
  return <SectionPortfolio />;
};
